import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import { useTranslation } from 'react-i18next';

/**
 * "Kimliği doğrulandı" rozeti. Yalnızca sunucunun hesapladığı `isIdentityVerified === true` iken görünür
 * (admin onaylı kimlik doğrulaması; başka KYC verisi istemciye gelmez).
 * variant: 'icon' (ad yanında simge + ipucu, ekran okuyucu etiketi) | 'chip' (metinli "Doğrulanmış profil" rozeti).
 * focusable=false: tıklanabilir kart/düğme içinde (iç içe odaklanabilir öğe olmasın) kullanılır.
 */
const VerifiedBadge = ({ verified, variant = 'icon', size = 16, focusable = true, sx = {} }) => {
  const { t } = useTranslation();
  if (verified !== true) return null;
  const label = t('verifiedBadge.tooltip');

  if (variant === 'chip') {
    return (
      <Tooltip title={label} arrow>
        <Chip
          icon={<VerifiedIcon aria-hidden />}
          label={t('verifiedBadge.label')}
          size="small"
          color="primary"
          variant="outlined"
          data-testid="verified-badge"
          sx={{ fontWeight: 700, ...sx }}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={label} arrow>
      <Box
        component="span"
        role="img"
        aria-label={label}
        tabIndex={focusable ? 0 : undefined}
        data-testid="verified-badge"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          flexShrink: 0,
          color: 'primary.main',
          verticalAlign: 'middle',
          borderRadius: '50%',
          '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 1 },
          ...sx,
        }}
      >
        <VerifiedIcon sx={{ fontSize: size }} aria-hidden />
      </Box>
    </Tooltip>
  );
};

export default VerifiedBadge;
